import { render, staticRenderFns } from "./EditCustomerDocument.vue?vue&type=template&id=516878be"
import script from "./EditCustomerDocument.vue?vue&type=script&lang=js"
export * from "./EditCustomerDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports